import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { useChartSettings } from "@/hooks/useChartSettings"
import { cn } from "@/lib/utils"
import { CHART_TYPE_ICON } from "@/lib/lytick/chartTypeIcons"

export function ChartTypeTrigger() {
  const { activeChartType, chartTypeOptions, setChartType } = useChartSettings()
  const ActiveIcon = CHART_TYPE_ICON[activeChartType]

  return (
    <Tooltip>
      <Popover>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <button
              type="button"
              id="chart-type-btn"
              aria-label="Select chart type"
              className="relative inline-flex items-center justify-center w-9 h-9 rounded-[var(--radius-md)] text-[color:var(--lyt-text-muted)] transition-colors duration-[var(--duration-fast)] hover:bg-[var(--surface-tint-hover)] hover:text-[color:var(--lyt-text-secondary)] border-0 bg-transparent cursor-pointer focus-visible:outline-none"
            >
              <ActiveIcon className="h-3.5 w-3.5" />
            </button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent side="bottom" sideOffset={6}>
          Chart type
        </TooltipContent>
        <PopoverContent
          align="start"
          className="w-60 border p-2"
          style={{
            backgroundColor: "var(--bg-elevated)",
            borderColor: "var(--lyt-border-default)",
            borderRadius: "var(--radius-lg)",
            boxShadow: "var(--shadow-xl)",
          }}
        >
          <div className="grid grid-cols-2 gap-1.5">
            {chartTypeOptions.map((option) => {
              const active = option.value === activeChartType
              const OptionIcon = CHART_TYPE_ICON[option.value]
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => setChartType(option.value)}
                  className={cn(
                    "interactive interactive-list flex items-center gap-2 rounded-md border px-3 py-2 text-left",
                    active && "interactive-selected",
                  )}
                  style={{
                    backgroundColor: active
                      ? "color-mix(in srgb, var(--accent-primary) 12%, transparent)"
                      : "transparent",
                    borderColor: active ? "var(--accent-primary)" : "var(--lyt-border-subtle)",
                  }}
                  aria-pressed={active}
                >
                  <span style={{ color: active ? "var(--accent-primary)" : "var(--text-muted)" }}>
                    <OptionIcon className="h-3.5 w-3.5" />
                  </span>
                  <span style={{
                    fontSize: "var(--text-sm)",
                    color: active ? "var(--accent-primary)" : "var(--text-primary)",
                  }}>
                    {option.label}
                  </span>
                </button>
              )
            })}
          </div>
        </PopoverContent>
      </Popover>
    </Tooltip>
  )
}
